import AuthProtect from "components/Auth/AuthProtect";
import { LayoutDefault } from "layouts/Default";
import { PATH_APP } from "routes/paths";
import Template from "./pages/templates";
const verdePushRoutes = {
  element: (
    <AuthProtect>
      <LayoutDefault />
    </AuthProtect>
  ),
  children: [
    {
      path: PATH_APP.verdePush.root,
      element: <Template />,
    },
  ],
};

export default verdePushRoutes;
